import http from "api/https";

// Получить все исходящие документы
export const getOutgoingDocuments = (): Promise<any> => {
  return http.get("/OutgoingDocument/GetAll");
};

// Получить исходящие документы по ID approval_request
export const getOutgoingDocumentsByApprovalRequest = (approval_request_id: number): Promise<any> => {
  return http.get(`/OutgoingDocument/GetByApprovalRequestId?approvalRequestId=${approval_request_id}`);
};

// Получить один исходящий документ по ID
export const getOutgoingDocument = (id: number): Promise<any> => {
  return http.get(`/OutgoingDocument/GetOneById?id=${id}`);
};

// Создать новый исходящий документ
export const createOutgoingDocument = (data: any, fileName: string, file): Promise<any> => {
  const formData = new FormData();
  
  for (var key in data) {
    if (data[key] == null) continue;
    formData.append(key, data[key]);
  }
  
  if (file && fileName) {
    formData.append("document.name", fileName);
    formData.append("document.file", file);
  }

  return http.post("/OutgoingDocument/Create", formData);
};

// Обновить исходящий документ
export const updateOutgoingDocument = (data: any, fileName: string, file): Promise<any> => {
  const formData = new FormData();
  
  for (var key in data) {
    if (data[key] == null) continue;
    formData.append(key, data[key]);
  }
  
  if (file && fileName) {
    formData.append("document.name", fileName);
    formData.append("document.file", file);
  }

  return http.put(`/OutgoingDocument/Update`, formData);
};

// Удалить исходящий документ
export const deleteOutgoingDocument = (id: number): Promise<any> => {
  return http.remove(`/OutgoingDocument/Delete?id=${id}`,{});
};

// Получить пагинированные исходящие документы
export const getOutgoingDocumentsPaginated = (pageSize: number, pageNumber: number): Promise<any> => {
  return http.get(`/OutgoingDocument/GetPaginated?pageSize=${pageSize}&pageNumber=${pageNumber}`);
};

// Следующие методы отсутствуют в контроллере, но оставлены для обратной совместимости
// При необходимости нужно добавить соответствующие эндпоинты в контроллер

// Получить исходящие документы по ID входящего документа
export const getOutgoingDocumentsByIncomingDocument = (incoming_document_id: number): Promise<any> => {
  return http.get(`/OutgoingDocument/by_incoming_document/${incoming_document_id}`);
};

// Получить исходящие документы по типу документа
export const getOutgoingDocumentsByType = (document_type_id: number): Promise<any> => {
  return http.get(`/OutgoingDocument/by_document_type/${document_type_id}`);
};

// Получить исходящий документ по номеру
export const getOutgoingDocumentByNumber = (document_number: string): Promise<any> => {
  return http.get(`/OutgoingDocument/by_number/${document_number}`);
};

// Получить финальные версии исходящих документов по approval_request
export const getFinalOutgoingDocuments = (approval_request_id: number): Promise<any> => {
  return http.get(`/OutgoingDocument/final/${approval_request_id}`);
};

// Получить исходящие документы, отправленные в BGA
export const getSentToBgaDocuments = (approval_request_id: number): Promise<any> => {
  return http.get(`/OutgoingDocument/sent_to_bga/${approval_request_id}`);
};

// Получить исходящие документы по подписавшему
export const getOutgoingDocumentsBySignedBy = (signed_by: number): Promise<any> => {
  return http.get(`/OutgoingDocument/by_signed_by/${signed_by}`);
};

// Получить исходящие документы по подготовившему
export const getOutgoingDocumentsByPreparedBy = (prepared_by: number): Promise<any> => {
  return http.get(`/OutgoingDocument/by_prepared_by/${prepared_by}`);
};


export const downloadFile = (id: number): Promise<any> => {
  return http.get(`/OutgoingDocument/DownloadDocumentByID?id=${id}`, {}, );
};